// extracted by mini-css-extract-plugin
export default {"wrapper":"Hga","container":"Iga","image":"Jga","info":"Kga","title":"Lga","note":"Mga","product":"Nga","product_img":"Oga","description":"Pga","name":"Qga","whybtn":"Rga","buttons":"Sga"};
    if(module.hot) {
      // 1726593108545
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  